/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react';
import {
  DomLayout,
  fabuildingsclassicregular,
  FontAwesomeIcon,
  GrcButton,
  GrcButtonType,
  GrcCheckBox,
  GrcDateTimeFormat,
  GrcDateTimePickerWrapper,
  GrcGrid,
  GrcPickerType,
  GrcSelectBox,
  gridOptions,
  IconProp
} from '@grc/ui-package';
import { useViewProfile } from '../view-profile/useViewProfile';
import PhoneIcon from './Icons/phone-icon';
import EmailIcon from './Icons/mail-icon';
import AutoReply from './auto-reply/auto-reply';
import './view-profile.scss';

export default function ViewProfile() {
  const {
    localeData,
    profileData,
    contacts,
    influencers,
    approvalWorkflows,
    delegates,
    initialDelegations,
    columnDefs,
    gridRef,
    pickUpFromDate,
    pickUpToDate,
    isOutOfOffice,
    formData,
    handlePickUpFromDateChange,
    handlePickUpToDateChange,
    handleClear,
    setIsOutOfOffice,
    setFormData
  } = useViewProfile();

  const [isPopupVisible, setIsPopupVisible] = useState(false);

  return (
    <div className="profile-card view-profile-page mb-3">
      <div className="profile-header row g-2 align-items-stretch">
        {/* Left Profile Card */}
        <div className="col-md-6">
          <div className="profile-summary-card mockup-layout">
            {/* LEFT: Avatar Section */}
            <div className="profile-left">
              <img
                src={profileData.avatar}
                alt={profileData.fullName}
                className="profile-avatar"
              />
              <div className="profile-name">{profileData.fullName}</div>
              <div className="profile-role">{profileData.alias}</div>
            </div>

            {/* RIGHT: Details Section */}
            <div className="profile-right">
              <div className="contact-line">
                <span className="icon-box">
                  <PhoneIcon />
                </span>
                <span>{profileData.phone}</span>
              </div>

              <div className="contact-line">
                <span className="icon-box">
                  <EmailIcon />
                </span>
                <span>{profileData.email}</span>
              </div>
              <div className="contact-line">
                <span className="icon-box">
                  <FontAwesomeIcon
                    icon={fabuildingsclassicregular as IconProp}
                  />
                </span>
                <div>
                  <div className="company-line">{profileData.companyName}</div>
                  <div className="address-line">
                    {`${profileData.companyAddress.street}, ${profileData.companyAddress.city}, ${profileData.companyAddress.state} ${profileData.companyAddress.zip}`}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Working Info */}
        <div className="col-md-6">
          <div className="info-card working-info-card">
            {/* Header */}
            <div className="info-title">{localeData.WorkingInfo}</div>

            {/* Body */}
            <div className="info-content">
              {/* First row: 2 columns */}
              <div className="row mb-2">
                <div className="col-6">
                  <div className="info-label">{localeData.WorkingDays}</div>
                  <div className="info-value">
                    {localeData.WorkingDaysRange}
                  </div>
                </div>

                <div className="col-6">
                  <div className="info-label">{localeData.Hours}</div>
                  <div className="info-value">
                    {localeData.WorkingHoursRange}
                  </div>
                </div>
              </div>

              {/* Second row */}
              <div>
                <div className="info-label">{localeData.ReportingTo}</div>
                <div className="info-value">{profileData.reportingTo}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row g-2 mt-2">
        <div className="col-md-6">
          <div className="info-card">
            <div className="info-title">{localeData.Contacts}</div>
            <div className="info-content tag-container">
              {contacts.map((c: any) => (
                <span key={c.id} className="location-tag">
                  {c.name}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="info-card">
            <div className="info-title">{localeData.Influencer}</div>
            <div className="info-content tag-container">
              {influencers.map((i: any) => (
                <span key={i.id} className="location-tag">
                  {i.name}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="section-divider" />
      <div className="info-card mt-3">
        <div className="info-title">{localeData.WorkflowDelegation}</div>

        <div className="info-content row g-2 align-items-end">
          <div className="col-md-2">
            <label className="grc-label">{localeData.UserName}</label>
            <div className="grc-value">{profileData.alias}</div>
          </div>

          <div className="col-md-2">
            <label className="grc-label">{localeData.ApprovalWorkflow}</label>
            <GrcSelectBox
              id="approval_workflow_select"
              items={approvalWorkflows}
              displayExpr="text"
              valueExpr="id"
              value={formData.approvalWorkflow}
              placeholder={localeData.Select}
              onValueChange={value =>
                setFormData({ ...formData, approvalWorkflow: value })
              }
            />
          </div>

          <div className="col-md-2">
            <label className="grc-label">{localeData.FromDate}</label>
            <GrcDateTimePickerWrapper
              id="workflow_from_date"
              pickerType={GrcPickerType.Calendar}
              format={GrcDateTimeFormat.Date}
              value={pickUpFromDate}
              onValueChange={handlePickUpFromDateChange}
            />
          </div>

          <div className="col-md-2">
            <label className="grc-label">{localeData.ToDate}</label>
            <GrcDateTimePickerWrapper
              id="workflow_to_date"
              pickerType={GrcPickerType.Calendar}
              format={GrcDateTimeFormat.Date}
              value={pickUpToDate}
              onValueChange={handlePickUpToDateChange}
            />
          </div>

          <div className="col-md-2">
            <label className="grc-label">{localeData.Delegatee}</label>
            <GrcSelectBox
              id="delegatee_select"
              items={delegates}
              displayExpr="text"
              valueExpr="id"
              value={formData.delegatee}
              placeholder={localeData.Select}
              onValueChange={value =>
                setFormData({ ...formData, delegatee: value })
              }
            />
          </div>

          <div className="col-md-2 d-flex gap-2">
            <GrcButton
              id="workflow_clear_button"
              type={GrcButtonType.Default}
              text={localeData.Clear}
              onClick={handleClear}
            />
            <GrcButton
              id="workflow_add_button"
              type={GrcButtonType.Normal}
              text={localeData.Add}
            />
          </div>
        </div>
      </div>

      <div className="mt-3" data-testid="workflow_delegation_grid">
        <GrcGrid
          gridRef={gridRef}
          rowData={initialDelegations}
          colDefs={columnDefs}
          gridOptions={gridOptions}
          domLayout={DomLayout.AutoHeight}
          isPagination
        />
      </div>
    </div>
  );
}
